import { render } from "./wokerDetail14.vue?vue&type=template&id=3fbdcf1c&scoped=true"
import script from "./wokerDetail14.vue?vue&type=script&lang=js"
export * from "./wokerDetail14.vue?vue&type=script&lang=js"

import "./wokerDetail14.vue?vue&type=style&index=0&id=3fbdcf1c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3fbdcf1c"]])

export default __exports__